import { render, staticRenderFns } from "./ThgImprint.vue?vue&type=template&id=e3fd0e4a&scoped=true"
import script from "./ThgImprint.vue?vue&type=script&lang=ts"
export * from "./ThgImprint.vue?vue&type=script&lang=ts"
import style0 from "./ThgImprint.vue?vue&type=style&index=0&id=e3fd0e4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3fd0e4a",
  null
  
)

export default component.exports